import React from "react";
import DatePicker from "react-datepicker";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import { Input } from "semantic-ui-react";

import WithFormField from "../WithFormField";

export function ControlledDateTimePicker({
  name,
  initialDate,
  required,
  errorMessage,
  dataTest,
  ...props
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: initialDate,
    rules: { required: { value: required, message: errorMessage } },
  });

  return (
    <DatePicker
      showYearDropdown
      scrollableYearDropdown
      {...props}
      onChange={field.onChange}
      selected={field.value}
      popperModifiers={[{ name: "arrow", options: { padding: 24 } }]}
      customInput={
        <Input
          fluid
          data-test={dataTest}
          ref={field.ref}
          value={field.value}
          onBlur={field.onBlur}
          error={Boolean(error)}
          icon="calendar outline"
        />
      }
    />
  );
}

ControlledDateTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  initialDate: PropTypes.instanceOf(Date),
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  dataTest: PropTypes.string,
};

ControlledDateTimePicker.defaultProps = {
  initialDate: null,
  required: false,
  errorMessage: "",
  dataTest: "controlled-datetime-picker",
};

export default WithFormField(ControlledDateTimePicker);
